import { Button } from "@heroui/react";
import { Card } from "@heroui/react";
import { motion } from "framer-motion";
import { TwitterMetadata } from "@/types/social-pay.types";

interface TwitterSessionExpiredNoticeProps {
  onReconnect: () => void;
  twitterMetadata: TwitterMetadata;
}

export const TwitterSessionExpiredNotice = ({
  onReconnect,
  twitterMetadata,
}: TwitterSessionExpiredNoticeProps) => {
  const { username, name, profilePicture } = twitterMetadata;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card className="p-6 bg-[#0C1113] shadow-md border border-gray-800/50">
        <div className="flex flex-col items-center gap-4 text-center">
          {profilePicture ? (
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
                delay: 0.1,
              }}
              className="w-16 h-16 rounded-full overflow-hidden"
            >
              <img
                src={profilePicture}
                alt={`${name || username}'s profile`}
                className="w-full h-full object-cover"
              />
            </motion.div>
          ) : (
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
                delay: 0.1,
              }}
            >
              <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center mb-2">
                <span className="text-white text-xl font-bold">X</span>
              </div>
            </motion.div>
          )}

          <h3 className="text-xl font-semibold text-white">Twitter Session Expired</h3>

          <div className="flex flex-col gap-2 max-w-sm">
            <p className="text-gray-400">
              Your connection with{" "}
              {name && (
                <span className="text-white font-medium">{name}</span>
              )}{" "}
              <span className="font-medium text-green-400">(@{username})</span>{" "}
              has expired.
            </p>
            <p className="text-gray-400">
              To complete this task, please reconnect your Twitter account.
            </p>
          </div>

          <Button
            className="bg-[#60FF8A] text-black font-semibold px-4 py-2 rounded-lg hover:bg-[#60FF8A]/90 transition-colors flex items-center justify-center"
            onPress={onReconnect}
          >
            Reconnect Twitter
          </Button>
        </div>
      </Card>
    </motion.div>
  );
};
